<template>
  <van-popup 
    ref="popup"
    v-model="show"
    position="bottom"
    overlay-class="mask-style"
    round safe-area-inset-bottom closeable
    :close-on-click-overlay="false"
  >
    <div class="main">
      <div class="title" style="margin-bottom:20px;">地址识别</div>
      <van-field
        v-model="value"
        rows="5"
        type="textarea"
        maxlength="200"
        show-word-limit
        clearable
        placeholder="粘贴或输入整段地址。例如，××省××市××大厦××号，姓名，187××××××××"
        style="background-color:#F5F5F5;border-radius:14px;overflow:hidden;margin-bottom:20px;"
      />
        <van-button 
          round block 
          type="warning" 
          color="#F1892E" 
          style="width:73%;margin:0 auto;"
          @click="submit"
        >识别填写</van-button>
    </div>
  </van-popup>
</template>

<script>
import { Popup , Icon , Field , Button  } from 'vant';
export default {
  components:{
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  props:['showIdentification','openSearch'],
  data(){
    return {
      value:'',
    }
  },
  watch:{
    showIdentification(nVal,oVal){
      if(nVal&&oVal!=nVal) this.value = '';
    }
  },
  computed:{
    show:{
      get(){
        return this.showIdentification;
      },
      set(val){
        this.$emit('update:showIdentification',val);
      }
    }
  },
  methods:{
    submit(){
      if(!this.value) return this.$toast({message:'内容不可为空',icon:'fail'});
      let [data] = window.AddressParse.parse(this.value);
      let params = {
        detailedAddress:data.province + data.city + data.area + data.details,
        factoryLinkName:data.name,
        factoryLinkPhone:data.mobile||data.phone,
        remark:data.details
      }
      this.show = false;
      // this.openSearch = true;
      this.$emit('confirm',params);
    }
  }

}
</script>

<style scoped lang="scss">
  .van-popup  {
    z-index: 9999 !important;
  }
  .main {
    padding: 20px 22px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #2B2B2B;
    }
  }

</style>